// SlidersSectionApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'SlidersSection'];

// Enhance the base API service by adding entication-related tag types
const SlidersSectionApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
        
      // Fetch SlidersSection query (GET request to /me)
      getSlidersSection: build.query({
        query: () => ({
          url: `/sliders`,
        }),
        providesTags: ['SlidersSection'],
      }),  
     
       
    }),
    overrideExisting: false,
  });

export default SlidersSectionApi;

// Exporting hooks for each endpoint to be used in components
export const {
     useGetSlidersSectionQuery,
 } = SlidersSectionApi;


